<template>
    <div class="block-editor probel-get-patient-token">
        <section class="active-connection">
            <div data-small="true" class="logos">
                <div class="logo1">
                    <img class="custom-block-logo" src="/static/img/supsis-logo2.png" />
                </div>
                <span class="material-icons"> add </span>
                <div class="logo2">
                    <img class="custom-block-logo" src="/static/img/chatbot/probel.png" />
                </div>
            </div>
            <div class="active-connection-text">
                <div><span>Connected with</span> <b> Probel API</b></div>
            </div>
        </section>
        <div class="probel-get-patient-token-wrapper">
            <div class="inputTitle">{{ $t("probel.identityType") }}</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    v-model="clone.identityType"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    :placeholder="$t('probel.identityTypeDesc')"
                    :rows="1"
                />
            </div>

            <div class="inputTitle mt-2">{{ $t("probel.identityNumber") }}</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    v-model="clone.identityNumber"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    :placeholder="$t('probel.identityNumberDesc')"
                    :rows="1"
                />
            </div>

            <div class="inputTitle mt-2">{{ $t("probel.name") }}</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    v-model="clone.name"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    :placeholder="$t('probel.nameDesc')"
                    :rows="1"
                />
            </div>

            <div class="inputTitle mt-2">{{ $t("probel.surname") }}</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    v-model="clone.surname"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    :placeholder="$t('probel.surnameDesc')"
                    :rows="1"
                />
            </div>

            <div class="inputTitle mt-2">{{ $t("probel.gender") }}</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    v-model="clone.gender"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    :placeholder="$t('probel.genderDesc')"
                    :rows="1"
                />
            </div>

            <div class="inputTitle mt-2">{{ $t("probel.birthDay") }}</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    v-model="clone.birthDay"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    :placeholder="$t('probel.birthDayDesc')"
                    :rows="1"
                />
            </div>

            <div class="inputTitle mt-2">{{ $t("probel.phoneNumber") }}</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    v-model="clone.phoneNumber"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    :placeholder="$t('probel.phoneNumberDesc')"
                    :rows="1"
                />
            </div>
        </div>
        <div class="inputTitle mt-5 mb-2 font-weight-bold">{{ $t("chatbotv2.followingAttributesFilled") }}</div>
        <section class="next-step-filled-items-wrapper">
            <div class="logos middle-section" v-for="attr in nextStepFilledValue" :key="attr">
                <AttributeIconPreview :attribute="attr" />
                <span class="ml-2">
                    <AttributeLabel :attribute="attr" />
                </span>
            </div>
        </section>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import TiptapEditor from "../../common/TiptapEditor";
import AttributeLabel from "../../common/tiptap-extensions/AttributeLabel";
import AttributeIconPreview from "../../common/AttributeIconPreview";

import _ from "lodash";

const log = log2("ProbelGetPatientToken");
export default {
    name: "ProbelGetPatientToken",
    components: { TiptapEditor, AttributeLabel, AttributeIconPreview },
    props: {
        value: {
            type: Object,
            default: () => ({
                identityType: "{{probel_kimlik_tipi}}",
                identityNumber: "{{probel_kimlik_no}}",
                name: "{{probel_hasta_adi}}",
                surname: "{{probel_hasta_soyadi}}",
                gender: "{{probel_hasta_cinsiyet}}",
                birthDay: "{{probel_hasta_dogum_tarihi}}",
                phoneNumber: "{{probel_hasta_telefon}}",
            }),
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            nextStepFilledValue: ["probel_hasta_token"],
        };
    },
    mounted() {
        log("mounted");
    },
    watch: {
        clone: {
            handler(val) {
                log("clone changed", val);
                this.$emit("input", val);
            },
            deep: true,
        },
        value(val) {
            if (_.isEqual(val, this.clone)) {
                return;
            }
            this.clone = _.cloneDeep(val);
        },
    },
};
</script>

<style lang="scss">
.block-editor.probel-get-patient-token {
    padding: 30px 30px 0;

    .active-connection {
        align-items: center;
        background: #fff;
        border-radius: 6px;
        display: flex;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        overflow: hidden;
        padding: 20px;
        width: 100%;
        word-break: break-word;

        .logos {
            align-items: center;
            display: flex;
            flex-shrink: 0;
            margin-right: 15px;
            margin-top: 4px;

            .logo1 {
                background: #4a6586;
            }

            .logo2 {
                background: rgba(208, 41, 46, 0.32);
            }

            .logo1,
            .logo2 {
                height: 30px;
                padding: 4px;
                width: 30px;
            }
        }

        .filled-attributes {
            margin: 0px 0px -17px -50px !important;
        }
    }

    .next-step-filled-items-wrapper {
        background: #fff;
        border-radius: 6px;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        padding: 20px;
        width: 100%;

        .middle-section {
            background: #ffdc66;
            cursor: pointer;
            transition: all 0.3s;
            border-radius: 10px;
            box-decoration-break: clone;
            display: flex;
            justify-content: center;
            padding: 5px;
            width: fit-content;
            margin: 5px;
            align-items: center;
            font-weight: 800;
        }
    }

    .active-connection-text {
        flex-grow: 1;
        flex-shrink: 0;
        width: 0;

        div {
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: pre-wrap;
        }
    }

    .probel-get-patient-token-wrapper {
        .inputTitle {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .editable-editor {
            p {
                margin-bottom: 0;
            }
        }
    }
}
</style>
